module.exports = __webpack_public_path__ + "static/fonts/1f6af904-724d-4f75-b836-51c3d674a37e.1748af2.eot";